<div class="cep-content" [formGroup]="formValidation">
    <div class="cep-fields-grid">
        <div class="columns-data">
            <div class="tem-field">
                <span class="tem-field-label">{{'correios.cepOrigin'|translateTA}}</span>
                <nz-input-group [nzSuffix]="origemSuffix">
                    <input nz-input formControlName="origem" [placeholder]="'correios.cepOrigin'|translateTA"
                           type="text" mask="00000-000" (keyup.enter)="pesquisar()" />
                </nz-input-group>
                <ng-template #origemSuffix>
                    <nz-icon nzType="close-circle" class="field-action" nz-tooltip
                             [nzTooltipTitle]="'correios.clear'|translateTA" (click)="clear('origem')" />
                </ng-template>
            </div>
        </div>
        <div class="columns-data">
            <div class="tem-field">
                <span class="tem-field-label">{{'correios.cepDest'|translateTA}}</span>
                <nz-input-group [nzSuffix]="destinoSuffix">
                    <input nz-input formControlName="destino" [placeholder]="'correios.cepDest'|translateTA"
                           type="text" mask="00000-000" (keyup.enter)="pesquisar()" />
                </nz-input-group>
                <ng-template #destinoSuffix>
                    <nz-icon nzType="close-circle" class="field-action" nz-tooltip
                             [nzTooltipTitle]="'correios.clear'|translateTA" (click)="clear('destino')" />
                </ng-template>
            </div>
        </div>
    </div>
    <button nz-button nzType="primary" type="button" (click)="pesquisar()">
        <nz-icon nzType="search" />{{'correios.search'|translateTA}}
    </button>
    <span class="mensagem" [class.msg-ok]="sucesso" [class.msg-err]="!sucesso">{{message}}</span>
</div>
